
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { QrCode } from "@/utils/label-layout/qr-code";
import {  Model } from "@/utils/models/model";
import Vue from "vue";
import AppQrCodeSettings from "./QrCodeSettings.vue";

export default Vue.extend({
	data(){
		return {
			toEditQrCodeIndex: -1
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		model():Model{
			return this.layout.getModel();
		}
	},
	methods: {
		addNewQrCode(){
			let code = new QrCode();
			this.layout.QrCodes.push(code);
			this.toEditQrCodeIndex = this.layout.QrCodes.length-1;
		},
		deleteQrCode(i:number){
			this.layout.QrCodes.splice(i,1);
		},
		editQrCode(code:QrCode){
			this.toEditQrCodeIndex = this.layout.QrCodes.indexOf(code);
		}
	},
	components: {
		AppQrCodeSettings
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
